import React from "react";
import { useHistory } from "react-router-dom";

const MenuItem = (props) => {
    let itemStyle = {
        marginTop: 7,
        marginLeft: 15,
        width: props.width || "50px"
    };

    let iconStyle = {
        alignSelf: "center",
        textDecorationLine: "none",
        height: "25px",
        width: "25px"
    };

    if (props.selectedIndex === props.index) {
        itemStyle.color = "blue";
        iconStyle.color = "blue";
    }

    const history = useHistory();
    const itemClicked = () => {
        history.push(props.link);
        props.itemSelected(props.index);
    };

    return (
        <div style={itemStyle} onClick={itemClicked}>
            <props.icon style={iconStyle} />
            <br />
            {props.description}
        </div>
    );
};

export default MenuItem;
